import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SelectedNonStdAccessory } from './selected_non_std_accessory';
import { selectedNonStandardAccessoriesDetails } from '../../core/state_selectors';

/**
 * Builds the SelectedNonStdAccessory components
 * @param {Object} props - Component props
 * @param {Array} props.accessories - list of selected accessories to be rendered
 * @param {Function} props.onRemove - The function to fire when the delete icon is clicked
 * @param {Function} props.onChange - The function to fire when the select is changed
 * @return {Array} Returns an array of SelectedNonStdAccessory components
 */
const _SelectedNonStdAccessoryList = ({ accessories, onChange, onRemove }) =>  (
    accessories.map((accessory) => {
        const { code, label } = accessory;
        return (
            <SelectedNonStdAccessory
                key={code}
                code={code}
                label={label}
                onRemove={onRemove}
                onChange={onChange}
            />
        );
    })
);

_SelectedNonStdAccessoryList.propType = {
    accessories: PropTypes.array,
    onRemove: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired
};

_SelectedNonStdAccessoryList.defaultProps = {
    accessories: []
};

/**
 * Maps state to props
 * @param {Object} state The redux state
 * @return {Object} props including selected accessories details from store
 */
const mapStateToProps = (state) => ({
    accessories: selectedNonStandardAccessoriesDetails(state)
});

/**
 * @todo: move actions to action creators
 * Map dispatch function to component props
 * @param {Function} dispatch - store's dispatch function
 * @returns {Object} props that contain onChange & onRemove function
 */
const mapDispatchToProps = (dispatch) => ({
    onChange: (item) => {
        dispatch({
            type: 'SET_VALUE_IN_ARRAY',
            value: item,
            itemKey: 'code',
            stateKey: 'vertical.quote',
            identifier: 'coverDetail.vehicle.nonStandardAccessories'
        });
    },
    onRemove: (item) => {
        dispatch({
            type: 'SET_VALUE_IN_ARRAY',
            value: item,
            stateKey: 'vertical.quote',
            identifier: 'coverDetail.vehicle.nonStandardAccessories'
        });
    }
});

const SelectedNonStdAccessoryList = connect(mapStateToProps, mapDispatchToProps)(_SelectedNonStdAccessoryList);
export { SelectedNonStdAccessoryList, _SelectedNonStdAccessoryList };
